import { FC } from 'react'

const ReedDisclaimer: FC<{ className: string }> = ({ className }) => (
  <p className={className} data-pw="apply-disclaimer">
    In order to submit this application, a Reed account will be created for you. As such, in addition to applying for
    this job, you will be signed up to all Reed’s services as part of the process. By submitting this application, you
    agree to Reed’s{' '}
    <a href="https://www.reed.co.uk/policies#termsConditions" target="_blank">
      Terms and Conditions
    </a>{' '}
    and acknowledge that your personal data will be transferred to Reed and processed by them in accordance with their{' '}
    <a href="https://www.reed.co.uk/policies#privacyPolicy" target="_blank">
      Privacy Policy.
    </a>
  </p>
)

export default ReedDisclaimer
